export const ErrorScreen: React.FC = () => (
  <div style={{ padding: "80px", fontSize: "large" }}>
    Semgrep encountered an unrecoverable error. Please email support@r2c.dev and
    let us know so we can fix it!
  </div>
);
